export const SPOTLIGHT_NAMES = {
	firstEntity: 'eoc-escalation-policies_first_entity',
};
